/**
 * * Нельзя указывать больше оодной сортировки иначе будет стандартная (используется только для задач)
 */
export class GetTaskListRequestSortModel {
  /**
   * * Сортировка по оценки времени
   */
  SortByEstimatedTime?: boolean = false;
  /**
   * * Сортировка по затраченному времени
   */
  SortBySpentTime?: boolean = false;
  /**
   * * Сортировка по дедлайну
   */
  SortByDeadline?: boolean = false;
  /**
   * * Сортировка по сложности
   */
  SortByDifficulty?: boolean = false;
  /**
   * * Сортировка по приоритету
   */
  SortByPriority?: boolean = false;
  constructor(obj?: Partial<GetTaskListRequestSortModel>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
